import {
  DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS,
  DASH_SET_ESTADO_INICIAL,
  DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS,
  DASH_SET_SEM_MANIFESTO_SUCCESS,
  DASH_SET_ULTIMA_CONSULTA_SUCCESS,
  DASH_SET_ULTIMA_SEMANA_SUCCESS,
} from '../actions/types';

const INITIAL_STATE = {
  documentosFiscais: {},
  origensDocumentosFiscais: {},
  dadosUltimaSemana: {},
  dataUltimaConsulta: '',
  totalSemManifesto: 0,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case DASH_SET_DOCUMENTOS_FISCAIS_SUCCESS:
      return { ...state, documentosFiscais: payload };
    case DASH_SET_ORIGEM_DOCUMENTOS_FISCAIS_SUCCESS:
      return { ...state, origensDocumentosFiscais: payload };
    case DASH_SET_ULTIMA_SEMANA_SUCCESS:
      return { ...state, dadosUltimaSemana: payload };
    case DASH_SET_ULTIMA_CONSULTA_SUCCESS:
      return { ...state, dataUltimaConsulta: payload };
    case DASH_SET_SEM_MANIFESTO_SUCCESS:
      return { ...state, totalSemManifesto: payload };
    case DASH_SET_ESTADO_INICIAL:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};
